import request from '../utils/request.js'

// 发起商品订单支付
export function payOrder({ orderNo, channelCode, redirectUrl }) {
  return request({
    url: '/api/v1/pay/payOrder',
    method: 'POST',
    data: { orderNo, channelCode, redirectUrl }
  })
}

// 返还料：作者立即退款（按作品）
export function refundNow({ bookId }) {
  return request({
    url: '/api/v1/pay/refundNow',
    method: 'POST',
    data: { bookId }
  })
}

// 资料操作页：一键退款（按作品退全部已支付订单）
export function refundPaidOrders({ bookId }) {
  return request({
    url: '/api/v1/pay/refundPaidOrders',
    method: 'POST',
    data: { bookId }
  })
}

// 已购买用户列表：按用户退款
export function refundPaidUser({ bookId, userId }) {
  return request({
    url: '/api/v1/pay/refundPaidUser',
    method: 'POST',
    data: { bookId, userId }
  })
}

// 返还料：作者正确收款（按作品）
export function confirmIncome({ bookId }) {
  return request({
    url: '/api/v1/pay/confirmIncome',
    method: 'POST',
    data: { bookId }
  })
}



// WEBPACK FOOTER //
// ./src/api/pay.js